import { useRef } from 'react';

export default function useDeepRef(value) {
  const valueRef = useRef(value);
  valueRef.current = value;

  return valueRef;
}
